import React from "react";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import { Link as RouterLink } from "react-router-dom";
import { useConfig } from "../config/ConfigProvider";
import { Path } from "../Path";
import { getEventIdForAttendedConvention } from "./attended-convention-config";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").AttendedConventions} props.convention
 */
const AttendedConventionChip = ({ convention }) => {
  const { conventionCalendarEvents } = useConfig();

  const eventId = getEventIdForAttendedConvention(conventionCalendarEvents, convention);
  if (!eventId) {
    return <Chip label={convention} variant="outlined" />;
  }

  return (
    <Chip label={convention} variant="outlined" clickable component={RouterLink} to={Path.events().event(eventId)} />
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").AttendedConventions[]} props.conventions
 */
export const PublisherAttendedConventionChips = ({ conventions }) => {
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ pt: 0.5 }}>
      {conventions.map((convention) => (
        <AttendedConventionChip key={convention} convention={convention} />
      ))}
    </Stack>
  );
};
